const closeAlertButton = document.getElementById('close-alert-btn');
const alertPopup = document.getElementById('alert-popup');

if (closeAlertButton) {
  closeAlertButton.addEventListener('click', () => {
    alertPopup.classList.replace('flex', 'hidden');
  });
}
